var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"px-0"},[_c('h5',{staticClass:"text-black text-center fw-600 mt-0 mb-2"},[_vm._v(_vm._s(_vm.title_chart))]),(_vm.chart_enabled)?_c('highcharts',{staticClass:"d-block mx-auto",attrs:{"options":_vm.chartOptions,"updateArgs":_vm.updateArgs}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }